import { tracker } from '@lessonup/analytics';
import { RegistrationVerificationExpired } from '@lessonup/teacher-modern';
import { useOnMountEffect } from '@lessonup/typescript-core/ui';
import React from 'react';
import { PageWrapper } from '../../../components/PageWrapper/PageWrapper';
import { RegistrationFormProps } from '../types';

type RegistrationVerificationLinkExpiredServiceWrapperProps = Pick<RegistrationFormProps, 'next'>;

export const RegistrationVerificationLinkExpiredServiceWrapper = (
  props: RegistrationVerificationLinkExpiredServiceWrapperProps
) => {
  const onRequestNewVerificationLink = () => {
    props.next();
  };

  useOnMountEffect(() => {
    tracker.events.registrationVerificationLinkExpired();
  });

  return (
    <PageWrapper>
      <RegistrationVerificationExpired onCTAClick={onRequestNewVerificationLink} />
    </PageWrapper>
  );
};
